module.exports = __webpack_public_path__ + "static/img/synopsis_bg.07949a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/synopsis_bg.png
// module id = 269c
// module chunks = 9